import { createContext, useContext, useState, ReactNode } from "react";

interface CartContextType {
  totalQuantity: number;
  increase: (amount?: number) => void;
  decrease: (amount?: number) => void;
  setTotalQuantity: (value: number) => void;
  reset: () => void;
}

const CartContext = createContext<CartContextType | undefined>(undefined);
interface CartProviderProps {
  children: ReactNode;
}

export function CartProvider({ children }: CartProviderProps) {
  const [totalQuantity, setTotalQuantityState] = useState<number>(0);

  const increase = (amount: number = 1) => {
    setTotalQuantityState((prev) => prev + amount);
  };

  const decrease = (amount: number = 1) => {
    setTotalQuantityState((prev) => Math.max(0, prev - amount));
  };

  const setTotalQuantity = (value: number) => {
    setTotalQuantityState(Math.max(0, value));
  };

  const reset = () => {
    setTotalQuantityState(0);
  };

  return (
    <CartContext.Provider
      value={{
        totalQuantity,
        increase,
        decrease,
        setTotalQuantity,
        reset,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
export function useCart() {
  const context = useContext(CartContext);

  if (!context) {
    throw new Error("useCart must be used within CartProvider");
  }

  return context;
}
